module.exports = __webpack_public_path__ + "media/onboarding/man-9781ed63.svg";